import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const Title = styled.p`
  ${Text('bodyText', 'alternate')};
`

export const TitleModal = styled.h1`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(1)};
`

export const GenericTextModal = styled.p`
  ${Text('bodyText', 'default')};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm' || 'md' || 'lg')} {
    margin-bottom: ${spacing(1)};
  }
`

export const GenericText = styled.p`
  ${Text('small', 'default')};
  margin-bottom: ${spacing(1)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm' || 'md' || 'lg')} {
    margin-bottom: ${spacing(2)};
  }
`

export const ViewOptionsContainer = styled.div`
  display: flex;
`

export const ViewOptionsIconContainer = styled.div`
  margin-top: ${spacing(0.5)};
`
